import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { gameAPI, registrationAPI } from '../utils/api';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';
import './AllGames.css';

const AllGames = () => {
  const { user } = useAuth();
  const [games, setGames] = useState([]);
  const [filteredGames, setFilteredGames] = useState([]);
  const [userRegistrations, setUserRegistrations] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadGames();
    if (user) {
      loadUserRegistrations();
    }
  }, [user]);

  useEffect(() => {
    if (filter === 'all') {
      setFilteredGames(games);
    } else {
      setFilteredGames(games.filter(game => game.category === filter));
    }
  }, [filter, games]);

  const loadGames = async () => {
    try {
      const response = await gameAPI.getAllGames();
      if (response.success) {
        const sortedGames = response.games.sort((a, b) => 
          new Date(a.game_date + ' ' + a.game_time) - new Date(b.game_date + ' ' + b.game_time)
        );
        setGames(sortedGames);
        setFilteredGames(sortedGames);
      }
    } catch (error) {
      console.error('Fehler beim Laden der Spiele:', error);
      toast.error('Fehler beim Laden der Spiele');
    } finally {
      setLoading(false);
    }
  };

  const loadUserRegistrations = async () => {
    try {
      const response = await registrationAPI.getMyRegistrationsList();
      if (response.success) {
        setUserRegistrations(response.registrations || []);
      }
    } catch (error) {
      console.error('Fehler beim Laden der Registrierungen:', error);
      // Kein Toast-Error, da optional
    }
  };

  const isUserRegistered = (gameId) => {
    return userRegistrations.some(reg => reg.game_id === gameId || reg.gameId === gameId);
  };

  const getCategoryName = (category) => {
    const categories = {
      'all': 'Alle Spiele',
      'bundesliga': 'Bundesliga',
      'champions-league': 'Champions League',
      'dfb-pokal': 'DFB-Pokal',
      'europa-league': 'Europa League'
    };
    return categories[category] || category;
  };


  if (loading) {
    return (
      <div className="loading">
        <p>Spiele werden geladen...</p>
      </div>
    );
  }

  return (
    <div className="all-games">
      <div className="container">
        <div className="page-header">
          <h1>Alle Spiele</h1>
          <p>Melde dich zu den kommenden Spielen an</p>
        </div>

        {/* Filter */}
        <div className="games-filter">
          <button
            className={filter === 'all' ? 'active' : ''}
            onClick={() => setFilter('all')}
          >
            Alle Spiele ({games.length})
          </button>
          <button
            className={filter === 'bundesliga' ? 'active' : ''}
            onClick={() => setFilter('bundesliga')}
          >
            Bundesliga ({games.filter(g => g.category === 'bundesliga').length})
          </button>
          <button
            className={filter === 'champions-league' ? 'active' : ''}
            onClick={() => setFilter('champions-league')}
          >
            Champions League ({games.filter(g => g.category === 'champions-league').length})
          </button>
          <button
            className={filter === 'dfb-pokal' ? 'active' : ''}
            onClick={() => setFilter('dfb-pokal')}
          >
            DFB-Pokal ({games.filter(g => g.category === 'dfb-pokal').length})
          </button>
        </div>

        {/* Games List */}
        <div className="games-list">
          {filteredGames.length === 0 ? (
            <div className="no-games">
              <p>Keine Spiele in dieser Kategorie gefunden.</p>
            </div>
          ) : (
            filteredGames.map(game => (
              <div key={game.id} className="game-item">
                <div className="game-info">
                  <div className="game-header">
                    <h3>{game.opponent}</h3>
                    <span className={`category-badge ${game.category}`}>
                      {getCategoryName(game.category)}
                    </span>
                  </div>

                  <div className="game-details">
                    <div className="detail-item">
                      <strong>Datum:</strong> {new Date(game.game_date).toLocaleDateString('de-DE')}
                    </div>
                    <div className="detail-item">
                      <strong>Uhrzeit:</strong> {game.game_time}
                    </div>
                    <div className="detail-item">
                      <strong>Ort:</strong> {game.location}
                    </div>
                  </div>

                  {user && (
                    <div className="user-registration-info">
                      {isUserRegistered(game.id) ? (
                        <div className="registration-status registered">
                          <span>✓ Du bist bereits angemeldet</span>
                        </div>
                      ) : (
                        <div className="registration-status available">
                          <span>Anmeldung möglich</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="game-actions">
                  {user ? (
                    isUserRegistered(game.id) ? (
                      <Link to={`/spiel/${game.id}`} className="btn btn-secondary">
                        Details ansehen
                      </Link>
                    ) : (
                      <Link to={`/spiel/${game.id}`} className="btn btn-primary">
                        Details & Anmeldung
                      </Link>
                    )
                  ) : (
                    <Link to={`/spiel/${game.id}`} className="btn btn-primary">
                      Details ansehen
                    </Link>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default AllGames;
